const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionChoice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    fill: "#F6F6FB",
    style: {
      fill: "#F6F6FB",
      fill: "color(display-p3 0.9647 0.9647 0.9843)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    stroke: "#D9E5F8",
    style: {
      stroke: "#D9E5F8",
      stroke: "color(display-p3 0.8494 0.8973 0.9718)",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 5.5,
    width: 13,
    height: 5,
    rx: 1.5,
    fill: "white",
    stroke: "#D9E5F8",
    style: {
      fill: "white",
      fillOpacity: 1,
      stroke: "#D9E5F8",
      stroke: "color(display-p3 0.8494 0.8973 0.9718)",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 12.5,
    width: 13.5,
    height: 5,
    rx: 1.5,
    fill: "white",
    stroke: "#D9E5F8",
    style: {
      fill: "white",
      fillOpacity: 1,
      stroke: "#D9E5F8",
      stroke: "color(display-p3 0.8494 0.8973 0.9718)",
      strokeOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionChoice);
export default __webpack_public_path__ + "static/media/question-choice.7aaed91f922b7a0ca9e9915a65b7f1d1.svg";
export { ForwardRef as ReactComponent };